import { Workflow } from '../../consts'
import { buildLUTs } from '../../utils'

type AsyncTaskNames =
  | 'processVizFiles'
  | 'computeAdoption'
  | 'processBaseGis'
  | 'assignBuildingsToArchetypes'
  | 'startUmiExport'

type AsyncTaskConfiguration = {
  route: string
  usesToasts: boolean
  slice: keyof typeof Workflow
  invalidateTags: string[] | null
}

type AsyncTasksConfigurations = {
  [key in AsyncTaskNames]: AsyncTaskConfiguration
}

export const AsyncTaskConfig: AsyncTasksConfigurations = {
  processVizFiles: {
    route: 'analysis/get_all_data',
    usesToasts: true,
    slice: Workflow.analysis,
    invalidateTags: ['Scenarios'],
  },
  computeAdoption: {
    route: 'analysis/compute_adoption',
    usesToasts: true,
    slice: Workflow.analysis,
    invalidateTags: null,
  },
  processBaseGis: {
    route: 'umibuilder/process_zip',
    usesToasts: true,
    slice: Workflow.umibuilder,
    invalidateTags: ['Active Project', 'Scenarios'],
  },
  assignBuildingsToArchetypes: {
    route: 'umibuilder/assign_buildings_to_archetypes',
    usesToasts: true,
    slice: Workflow.umibuilder,
    invalidateTags: ['Active Project', 'Scenarios'],
  },
  startUmiExport: {
    route: 'umibuilder/start_umi_export',
    usesToasts: true,
    slice: Workflow.umibuilder,
    invalidateTags: ['Active Project', 'Scenarios'],
  },
}
export const { enum: AsyncTask, arr: AsyncTasks } = buildLUTs(AsyncTaskConfig)

// TODO: Consider returning an object per workflow, or defining it per workflow in the firstplace
// To avoid needing to filter in extraReducer cases
export const filterAsyncTasksByWorkflow = (workflow: keyof typeof Workflow) => {
  return AsyncTasks.filter((task) => AsyncTaskConfig[task].slice === workflow)
}
